<ng-content select="[slot=sticky]"></ng-content>


<app-section-template [has32Padding]="true" [hasMinWidth]="hasMinWidth()">
  <div class="wrapper" [class.two-columns]="show2columns()">
    <div class="left-section">
      <ng-content select="[slot=left-section]"></ng-content>
    </div>
    <div class="main-section">
      @if (hasBreadcrumb()) {
        <div class="breadcrumbs-wrapper" [class.show]="showBreadcrumbAlways()">
          <ng-content select="[slot=breadcrumb-section]"></ng-content>
        </div>
      }

      <ng-content select="[slot=above-title]"></ng-content>

      @if (hasCustomTitle()) {
        <ng-content select="[slot=custom-title]"></ng-content>
      } @else {
        <div class="item-title {{titleCssClass()}} ">{{ pageTitle() || pageData()?.title }}</div>
      }


      @if (pageData() && showTags()) {
        <app-tag-section
          [customDateField]="customDateField()"
          [news]="pageData()" [showFullTagList]="true"></app-tag-section>
      }

      @if (hasCustomMain()) {
        @if (showLoader() && !pageData()) {
          <div class="loading-screen">
            <mat-spinner [mode]="'indeterminate'" class="bright-green"></mat-spinner>
          </div>
        } @else {
          <ng-content></ng-content>
        }
      }
      @if (pageData() && pageData()?.htmlDescription && !hasCustomMain()) {
        <div class="item-description"
             [innerHTML]="pageData()?.htmlDescription | safeHtml">
        </div>
      }

      <div class="paginator-wrapper">
        <ng-content select="[slot=pagination]"></ng-content>
      </div>

      <!--      <div class="collection-wrapper">-->
      <!--        <ng-content select="[slot=collection]"></ng-content>-->
      <!--      </div>-->

    </div>

    @if (!show2columns()) {
      <div class="right-section">
        <ng-content select="[slot=right-section]"></ng-content>
      </div>
    }
  </div>

</app-section-template>
